/**
 * Copyright ToolBelt Data Inc., 2021 All Rights Reserved
 */

import React from "react";
import FormNumberInput from "../../../../../common/components/FormNumberInput";
import InsightBox from "../InsightBox";

const FilterNumberInput = (props) => {
    const {
        ftOption,
        stateObj,
        handleKeyValueChange,
        handleSubmitFilter
    } = props;

    if (!ftOption) return null;

    const { id, label, placeholder, insight, preview, infoText } = ftOption;

    // The slice stores the full filter object at stateObj[id] after submit.
    // Unwrap to get the actual numeric value.
    const rawValue = stateObj?.[id];
    const currentValue = (typeof rawValue === 'object' && rawValue !== null)
        ? rawValue.value ?? ''
        : (rawValue ?? '');

    const handleSubmit = () => {
        if (currentValue !== '' && currentValue != null) {
            handleSubmitFilter({
                ...ftOption,
                value: currentValue
            });
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    return (
        <div>
            <FormNumberInput
                id={`${id}-number-input`}
                label={label}
                placeholder={placeholder}
                value={currentValue}
                onChange={(value) => handleKeyValueChange(id, value)}
                onBlur={handleSubmit}
                onKeyDown={handleKeyDown}
                isPreview={preview}
                infoText={infoText}
            />
            {insight && (
                <div style={{ marginTop: '8px' }}>
                    <InsightBox
                        text={insight.text}
                        title={insight.title}
                    />
                </div>
            )}
        </div>
    );
}

export default FilterNumberInput;